<template>
  <SplashWrapper hide-buttons>
    <iRow align="center">
      <iColumn :width="1200">
        <iHeading>INSPIRATION.CO TERMS OF SERVICE</iHeading>
        <iSpace />
        <iText overflow>
          These terms govern your use of the Inspiration platform and services. By accessing or using Inspiration, you agree to these terms.
        </iText>

        <iSpace />

        <iSubHeading>1. Eligibility and Registration</iSubHeading>

        <iText overflow>
          To use Inspiration, you must be of legal age and capable of forming a binding contract.
          You agree to provide accurate and complete information during registration.
        </iText>

        <iSpace />

        <iSubHeading>2. Use of Inspiration</iSubHeading>

        <iText overflow>
          You agree to use Inspiration in compliance with all applicable laws and regulations.
          Any use that violates the law or infringes on the rights of others is prohibited.
        </iText>

        <iSpace />

        <iSubHeading>3. Access and Account Security</iSubHeading>
        <iText overflow>
          You are responsible for maintaining the confidentiality of your account and agree to notify Inspiration immediately
          of any unauthorized access or use of your account.
        </iText>

        <iSpace />

        <iSubHeading>4. Affiliate Relationships</iSubHeading>

        <iText overflow>
          Inspiration acts as an intermediary between publishers and merchants.
          Publishers agree to adhere to affiliate marketing guidelines and promote merchants' products responsibly.
        </iText>

        <iSpace />

        <iSubHeading>5. Content Guidelines</iSubHeading>

        <iText overflow>
          Publishers agree not to promote prohibited content, including illegal, discriminatory, or harmful material.
          Inspiration reserves the right to remove content that violates these guidelines.
        </iText>

        <iSpace />

        <iSubHeading>6. Payments and Earnings</iSubHeading>

        <iText overflow>
          Inspiration facilitates payments between publishers and merchants.
          Publishers agree to follow payment terms and understand that earnings are subject to adjustments and
          deductions as outlined in agreements with merchants.
        </iText>

        <iSpace />

        <iSubHeading>7. Intellectual Property</iSubHeading>

        <iText overflow>
          You retain ownership of your content but grant Inspiration a license to use, display,
          and distribute it as necessary to provide services. You agree not to infringe on others' intellectual property rights.
        </iText>

        <iSpace />

        <iSubHeading>8. Termination</iSubHeading>

        <iText overflow>
          Inspiration reserves the right to suspend or terminate accounts for violations of these terms or for any reason at its discretion.
        </iText>


        <iSpace />

        <iSubHeading>9. Privacy</iSubHeading>

        <iText overflow>
          Inspiration values your privacy and handles personal information according to its Privacy Policy.
        </iText>

        <iSpace />

        <iSubHeading>10. Changes to Terms</iSubHeading>

        <iText overflow>
          Inspiration may modify these terms at any time, and continued use of the platform constitutes acceptance of the modified terms.
        </iText>
        <iText overflow>
          By using Inspiration, you agree to these terms and acknowledge that violation may result in account suspension or termination.
        </iText>
      </iColumn>
    </iRow>
    <iSpace :height="20" />
  </SplashWrapper>
</template>

<script>
import SplashWrapper from "@/components/splash/SplashWrapper.vue";

export default {
  name: "TermsOfService",
  components: { SplashWrapper },
};
</script>

<style scoped lang="scss">
.nav-container {
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 1;
}
.nav-bar {
  width: 100%;
  padding: 0 40px;
}
</style>
